import { render } from "./RadioButtonGroup.vue?vue&type=template&id=0f0af757"
import script from "./RadioButtonGroup.vue?vue&type=script&lang=js"
export * from "./RadioButtonGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__